import React, { ChangeEvent } from "react";
import {
  Box,
  Button,
  IconButton,
  InputLabel,
  Typography,
} from "@material-ui/core";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { SingleAssistedAffiliationFileName } from "../types";
import useAssistedAffiliationStyles from "../styles";

type FileUploadFieldProps = {
  field: SingleAssistedAffiliationFileName;
  title: string;
  file: File | null;
  error?: string;
  required?: boolean;
  accept?: string;
  onChange: (field: SingleAssistedAffiliationFileName) => (
    event: ChangeEvent<HTMLInputElement>
  ) => void;
  onRemove: (field: SingleAssistedAffiliationFileName) => void;
};

const FileUploadField = ({
  field,
  title,
  file,
  error,
  required = false,
  accept = ".jpg,.jpeg,.pdf",
  onChange,
  onRemove,
}: FileUploadFieldProps) => {
  const classes = useAssistedAffiliationStyles();
  const inputId = `assisted-affiliation-${field}`;

  return (
    <Box>
      <InputLabel className={classes.fieldLabel} shrink htmlFor={inputId}>
        {title}
        {required ? <span className={classes.requiredMark}> *</span> : null}
      </InputLabel>
      <input
        id={inputId}
        className={classes.hiddenInput}
        type="file"
        accept={accept}
        onChange={onChange(field)}
      />
      {file ? (
        <Box className={classes.uploadCard}>
          <Box className={classes.uploadInfo}>
            <Box className={classes.uploadFileIcon}>
              <CloudUploadOutlinedIcon fontSize="small" />
            </Box>
            <Box>
              <Typography variant="subtitle2">{file.name}</Typography>
              <Typography variant="caption" color="textSecondary">
                {Math.ceil(file.size / 1024)} KB
              </Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            aria-label={`Eliminar ${title}`}
            onClick={() => onRemove(field)}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <Box className={classes.uploadPlaceholder}>
          <Box className={classes.uploadInfo}>
            <Box className={classes.uploadEmptyIcon}>
              <CloudUploadOutlinedIcon fontSize="small" />
            </Box>
            <Box>
              <Typography className={classes.uploadTitle}>
                Adjunta un archivo
              </Typography>
              <Typography variant="caption" color="textSecondary">
                JPG o PDF hasta 25MB
              </Typography>
            </Box>
          </Box>
          <label htmlFor={inputId}>
            <Button
              component="span"
              variant="outlined"
              size="small"
              className={classes.attachButton}
            >
              Adjuntar archivo
            </Button>
          </label>
        </Box>
      )}
      {error ? (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      ) : null}
    </Box>
  );
};

export default FileUploadField;
